export default __webpack_public_path__ + "static/media/logo_square.c4d6a448.svg";